/** Smooth scroll to a section by id (respects the sticky header via scroll-margin). */
export function scrollToSection(id: string): void {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
